import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { Spin } from 'antd';
import { colorsPalette } from '../../styles/colors-palette';

interface CustomStyle {
  position?: React.CSSProperties['position'];
  left?: CSSSize;
  top?: CSSSize;
  transform?: React.CSSProperties['transform'];
}
interface LoaderProps {
  centerOfWindow?: boolean;
  customStyle?: CustomStyle;
}

function Loader({ centerOfWindow, customStyle }: LoaderProps): ReactElement {
  if (centerOfWindow) {
    return (
      <LoaderWrapper customStyle={customStyle}>
        <StyledLoader />
      </LoaderWrapper>
    );
  }
  return <StyledLoader />;
}

const StyledLoader = styled(Spin)`
  &.ant-spin .ant-spin-dot-item {
    background-color: ${colorsPalette.dustyBlue500};
  }
`;

const LoaderWrapper = styled.div<{ customStyle?: CustomStyle }>`
  position: ${({ customStyle }) => (customStyle?.position ? customStyle.position : 'fixed')};
  left: ${({ customStyle }) => (customStyle?.left ? customStyle.left : '50%')};
  top: ${({ customStyle }) => (customStyle?.top ? customStyle.top : '50%')};
  transform: ${({ customStyle }) =>
    customStyle?.transform ? customStyle.transform : 'translate(-50%, -50%)'};
`;

export { Loader };
